
import { map } from 'rxjs/operators';
import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IFileUpload, IPropertyFileUpload } from '../../shared/models/fileupload';
import { RestService } from '../providers/rest.service';
import { AuthenticationService } from '../auth/authentication.service';
import { IUser } from '../models/user'
import { Observable } from 'rxjs';

@Injectable()
export class FileUploadService extends RestService {

  User: any;
  constructor(protected http: HttpClient, protected Authentication: AuthenticationService) {
    super(http);
  }

  inputFileUpload = {} as IFileUpload;

  uploadFiles(filUploadValue: IFileUpload, selectedFiles: any) {

    this.User = this.Authentication.user;
    const frmData = new FormData();
    frmData.append("fileCategoryId", filUploadValue.fileCategoryId.toString());
    frmData.append("id", filUploadValue.id.toString());
    frmData.append("objectId", filUploadValue.objectId.toString());
    frmData.append("objectTypeId", filUploadValue.objectTypeId.toString());
    frmData.append("documentName", filUploadValue.documentName != null ? filUploadValue.documentName.toString() : '');
    frmData.append("type", filUploadValue.type.toString());
    frmData.append("loggedInUserId", filUploadValue.userId ? filUploadValue.userId : this.User.Id.toString());
    frmData.append("uploadType", filUploadValue.uploadType ? filUploadValue.uploadType : null);
    frmData.append("OfferGuid", filUploadValue.OfferGuid ? filUploadValue.OfferGuid : null);
    frmData.append("ImageGuid", filUploadValue.ImageGuid ? filUploadValue.ImageGuid : null);
    frmData.append("PrincipalPropertyType", filUploadValue.PrincipalPropertyType ? filUploadValue.PrincipalPropertyType : null);
    frmData.append("PrincipalGuid", filUploadValue.PrincipalGuid ? filUploadValue.PrincipalGuid : null);
    frmData.append("IsConfidentialityAgreementDoc", filUploadValue?.IsConfidentialityAgreementDoc ? 'true' : 'false');

    for (var i = 0; i < selectedFiles.length; i++) {
      frmData.append("fileUpload", selectedFiles[i]);
    }

    return this.post("/upload", frmData).pipe(
      map(response => {
        return response;
      }));
  }

  uploadFile(filUploadValue: IPropertyFileUpload) {
    this.User = this.Authentication.user;
    const frmData = new FormData();
    frmData.append('fileCategoryId', filUploadValue.fileCategoryId.toString());
    frmData.append('id', filUploadValue.id.toString());
    frmData.append('objectId', filUploadValue.objectId.toString());
    frmData.append('objectTypeId', filUploadValue.objectTypeId.toString());
    frmData.append('documentName', filUploadValue.documentName.toString());
    frmData.append('type', filUploadValue.type.toString());
    frmData.append('fileUpload', filUploadValue.documentName.toString());
    frmData.append('postedFile', filUploadValue.FileContent); // Sets the file content
    frmData.append("loggedInUserId", this.User.Id.toString());
    frmData.append("uploadType", filUploadValue.uploadType ? filUploadValue.uploadType : null);
    frmData.append("alText", filUploadValue.AlText ? filUploadValue.AlText : null);
    frmData.append("Caption", filUploadValue.Caption ? filUploadValue.Caption : null);
    frmData.append("Description", filUploadValue.Description ? filUploadValue.Description : null);
    frmData.append("DisplayOrder", filUploadValue.DisplayOrder ? filUploadValue.DisplayOrder.toString() : null);
    frmData.append("isDefault", filUploadValue.isDefault.toString());
    frmData.append("ImageGuid", filUploadValue.ImageGuid ? filUploadValue.ImageGuid : null);
    frmData.append("PrincipalPropertyType", filUploadValue.PrincipalPropertyType ? filUploadValue.PrincipalPropertyType : null);
    frmData.append("IsConfidentialityAgreementDoc", filUploadValue?.IsConfidentialityAgreementDoc ? 'true' : 'false');
    return this.post('/upload', frmData).pipe(
      map(response => {
        return response;
      }));
  }

  downloadDoc(Id: string): Observable<any> {
    let url = this.getBaseUrl + "/upload/file/1/test/2";
    return this.http.get(url, { responseType: "blob" });
  }
  downloadDocByUrl(url: string) {
    return this.http.get(url, { responseType: "blob" });
  }
  // Gets the list of states
  GetLOIPath(objectId: number) {
    return this.GET('upload/GetLOIPath/' + objectId);
  }
}
